import styled from 'styled-components';

export const PaginationContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 24px;
  box-sizing: border-box;
`;

export const PaginationOptionsContainer = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  gap: 16px;
  width: 100%;

  span {
    color: rgb(62, 76, 89);
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    letter-spacing: 0em;
    line-height: 1.5rem;
    font-weight: 400;
  }

  select {
    width: auto;
  }
`;

export const Pagination = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: end;
  justify-content: flex-end;
  width: 100%;
  gap: 40px;

  p {
    color: rgb(62, 76, 89);
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    letter-spacing: 0em;
    line-height: 1.5rem;
    font-weight: 400;
  }

  div {
    display: flex;
    -webkit-box-align: center;
    align-items: center;

    button {
      display: flex;
      width: 40px;
      height: 40px;
      border-radius: 8px;
      flex-direction: column;
      -webkit-box-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      align-items: center;
      border: none;
      cursor: pointer;
      background: none;

      span {
        color: rgb(31, 41, 51);
        font-family: Inter, sans-serif;
        font-size: 0.875rem;
        letter-spacing: 0em;
        line-height: 1.5rem;
        font-weight: 400;
      }

      svg {
        width: 16px;
        height: 16px;
        color: rgb(31, 41, 51);
      }

      &:hover {
        background: rgb(245, 247, 250);
      }
      &.active {
        background: rgb(240, 252, 249) !important;
      }
      &:disabled {
        background: none;
        cursor: default;

        svg,
        span {
          color: rgb(123, 135, 148) !important;
        }
      }
    }
  }
`;
